const useIsPlaywriteEnvironment = () => {
    return '__playwright__binding__' in window || '__pwInitScripts' in window || Boolean((window as any).playwright);
};

export default useIsPlaywriteEnvironment;
